export default "__VITE_ASSET__CtHHvVlh__"